export class MessagingService {
	constructor($http, $translate) {
		'ngInject';
		this.$http = $http;
		this.$translate = $translate;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}
	sendMessageToRealEstateAgent(params, captcha) {
		return this.$http({
			method: 'POST',
			url: `${this.publicRoot}/message/agent`,
			data: params,
			headers: {captcha: JSON.stringify(captcha)}
		});
	}
	sendMessageToPerson(params, captcha) {
		let vm = this;
		let currentLang = this.$translate.use();
		this.$translate.use(params.lang);
		return this.$translate('ANYIT.shareSubject').then((share) => {
			params.subject = share;
			vm.$translate.use(currentLang);
			return vm.$http({
				method: 'POST',
				url:`${this.publicRoot}/share`,
				data: params,
				headers: {captcha: JSON.stringify(captcha)}
			});
		});
	}
	sendGeneralMessage(params, captcha) {
		return this.$http({
			method: 'POST',
			url:`${this.publicRoot}/message`,
			data: params,
			headers: {captcha: JSON.stringify(captcha)}
		});
	}
	sendAskCallback(params, captcha) {
		return this.$http({
			method: 'POST',
			url:`${this.publicRoot}/message/askCallback`,
			data: params,
			headers: {captcha: JSON.stringify(captcha)}
		});
	}
	share(params, captcha){
		let vm = this;
		let currentLang = this.$translate.use();
		this.$translate.use(params.lang);
		return this.$translate('ANYIT.shareSubject').then((share) => {
			params.subject = share;
			vm.$translate.use(currentLang);
			return this.$http({
				method: 'POST',
				url:`${this.publicRoot}/share`,
				data: params,
				headers: {captcha: JSON.stringify(captcha)}
			});
		}).catch(() => {
			params.subject = 'SHARE';
			vm.$translate.use(currentLang);
			return this.$http({
				method: 'POST',
				url:`${this.publicRoot}/share`,
				data: params,
				headers: {captcha: JSON.stringify(captcha)}
			});
		});
	}
}
